import AbsComponent from '../../common/components/AbsComponent';
import Utils from '../../common/Utils';

/**
 * Promotion class
 * @category mainApp
 */
class Promotion extends AbsComponent{
	constructor( _el = '') {
		super(_el);


		this.render();

	}


	render() {


		$('.promotion-banner-list').slick({
			dots: false,
			arrows: true,
			infinite: true,
			prevArrow: $('.promotion-nav .btn-prev'),
			nextArrow: $('.promotion-nav .btn-next'),
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 9000,
			cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)'
		}).on('beforeChange', function(event, slick, currentSlide, nextSlide){
			// console.log('* promotion : ', currentSlide , nextSlide , slick.currentDirection );
			// .banner_nav_list
			if(!$(`.promotion-nav-list li[data-slick-index=${nextSlide}]`).hasClass('slick-active')) {
				// nav 판 이동시
				if(nextSlide > currentSlide && currentSlide != 0) {
					$('.promotion-nav-list').slick('slickNext');
				} else if(currentSlide + 1 == slick.slideCount && nextSlide == 0){
					$('.promotion-nav-list').slick('slickNext');
				} else {
					$('.promotion-nav-list').slick('slickPrev');
				}
				$('.promotion-nav-list li').removeClass('slick-current');
				$(`.promotion-nav-list li[data-slick-index=${nextSlide}]`).addClass('slick-current');
			} else {
				// 판 이동없이 current 변경시
				$('.promotion-nav-list li').removeClass('slick-current');
				$(`.promotion-nav-list li[data-slick-index=${nextSlide}]`).addClass('slick-current');
			}
		});



		var wrap = $('.section-promotion');
		const slickLength = $('.promotion-banner-list').slick("getSlick").slideCount;
		$('.promotion-nav-count', wrap).empty().html(`<strong>1</strong>/${slickLength}`);


		$('.promotion-banner-list').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			$('.promotion-nav-count', wrap).empty().html(`<strong>${nextSlide + 1}</strong>/${slick.slideCount}`);
		});


		$('.promotion-nav-list').slick({
			dots: false,
			arrows: false,
			infinite: true,
			slidesToShow: 5,
			slidesToScroll: 5,
			swipe: false
		});
		$(window).on('resize orientationchange', function() {
			$('.promotion-banner-list').slick('resize');
			$('.promotion-nav-list').slick('resize');
		});


		$('.promotion-nav-list .promotion-nav-item').on('click', (e) => {
			if($(e.currentTarget).hasClass('slick-current')) return false;

			$(e.currentTarget).siblings().removeClass('slick-current');
			$(e.currentTarget).addClass('slick-current');

			$('.promotion-banner-list').slick('slickGoTo', $(e.currentTarget).data('slick-index'));
		});

		// 전체보기, 닫기버튼
		$('.btn-listall', this.wrap).on('click', (e) => {
			// $('.promotion-layer').toggle();
			$('.promotion-layer').toggleClass('is-show');
			$(e.target).toggleClass('is-close');
		});

		// nav over autoplay 정지
		$('.promotion-nav-list').on('mouseover', (e) => {
			$('.promotion-banner-list').slick('slickPause');
		});
		$('.promotion-nav-list').on('mouseout', (e) => {
			$('.promotion-banner-list').slick('slickPlay');
		});




		this.setting();
		this.addEvents();
	}

	setting(){



	}
	addEvents(){



	}
}

export default Promotion;